import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add, AddAlert, TableChart } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useState } from "react";
import {
  Button,
  Create,
  RadioButtonGroupInput,
  SelectInput,
  TextInput,
  Toolbar,
  maxValue,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { ServiceableTransactionTypeKey } from "../../../../Constants/Constant";
import { GetCarrierType } from "../../../../Enums/CarrierType";
import { ServiceableStatu } from "../../../../Enums/ServiceableStatus";
import { ShippingType } from "../../../../Enums/ShippingType";
import { useAppDataProvider } from "../../../../dataprovider";
import { ShippingTypeChoices } from "../../Constant/Source";
import { RequestServiceablePostModel } from "../../Models/RequestServiceableModel";
import ExperienceSoftWarningDialog from "../ExperiencePopup";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const ServiceableCreate = props => {
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const requestId = props.requestId;

  const CreateServiceableButtonClick = e => {
    CreateServiceable(e);
  };

  function isReceiving() {
    return props?.requestDetail?.transactionType === ServiceableTransactionTypeKey;
  }

  const CreateServiceable = async e => {
    let requestServiceableCreateModel: RequestServiceablePostModel = new RequestServiceablePostModel();
    requestServiceableCreateModel.RequestId = requestId;
    requestServiceableCreateModel.Awb = e.serviceableAwb;
    requestServiceableCreateModel.CarrierEnum = e.serviceableCarrierEnum;
    requestServiceableCreateModel.EstimatedDeliveryDate = e.serviceableEstimatedDeliveryDate;
    requestServiceableCreateModel.FlightDate = e.serviceableFlightDate;
    requestServiceableCreateModel.FlightNo = e.serviceableFlightNo;
    requestServiceableCreateModel.Pn = e.serviceablePn;
    requestServiceableCreateModel.Sn = e.serviceableSn;
    requestServiceableCreateModel.RequestedDeliveryDate = new Date();
    requestServiceableCreateModel.Status = ServiceableStatu.Offered;
    requestServiceableCreateModel.SubmittedBy = user?.employeeId;
    requestServiceableCreateModel.SubmittedDate = new Date();
    requestServiceableCreateModel.ShippingTypeEnum = e.shippingTypeEnum;

    PostCreate(requestServiceableCreateModel);
  };

  const PostCreate = async (createModel: RequestServiceablePostModel) => {
    setLoading(true);
    dataProvider
      .postRequestServiceable(createModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record created`, "success", false, true);
        history.push("/requestorders/" + requestId + "/1");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };

  return (
    <>
      <Form
        onSubmit={CreateServiceableButtonClick}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Create {...props}>
                  <>
                    <Separator />
                    <Grid {...gridContainerProps}>
                      {isReceiving() && (
                        <Chip
                          key={999999}
                          color="primary"
                          variant="outlined"
                          label={props?.requestDetail?.transactionType}
                          icon={<TableChart />}
                        />
                      )}
                      <SectionTitle label="Serviceable Info" />
                    </Grid>
                    <Separator />
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <RadioButtonGroupInput
                          source="shippingTypeEnum"
                          label="Shipping Type"
                          defaultValue={ShippingType.RBH}
                          fullWidth
                          choices={ShippingTypeChoices}
                          variant="outlined"
                        />
                        <TextInput
                          source="serviceablePn"
                          label="PN"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="serviceableAwb"
                          label="AWB No"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="serviceableFlightNo"
                          label="Flight No"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="serviceableSn"
                          label="SN"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}></Grid>
                      <Grid item xs={12} sm={5} />
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <SelectInput
                          source="serviceableCarrierEnum"
                          label="Carrier"
                          choices={GetCarrierType}
                          optionText="Description"
                          optionValue="Value"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                        />
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <CustomDatetime
                          fullWidth
                          source="serviceableFlightDate"
                          label="Flight Date"
                          inputVariant={"dialog"}
                          variant="outlined"
                          showTime
                          maxDate={values.serviceableEstimatedDeliveryDate}
                          validate={[required(), maxValue(values.serviceableEstimatedDeliveryDate)]}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                        />
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}></Grid>
                      <Grid item xs={12} sm={5}>
                        <CustomDatetime
                          fullWidth
                          source="serviceableEstimatedDeliveryDate"
                          label="Estimated Delivery Date"
                          inputVariant={"dialog"}
                          variant="outlined"
                          showTime
                          minDate={values.serviceableFlightDate}
                          validate={minValue(values.serviceableFlightDate)}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                        />
                      </Grid>
                    </Grid>
                    <Separator />
                    {isReceiving() && (
                      <Chip
                        key={999999}
                        color="primary"
                        variant="outlined"
                        label="Core RN dönüşüdür, çıkış RN yapılmalıdır!"
                        icon={<AddAlert />}
                      />
                    )}
                    <Toolbar {...props} placeholder="" classes={classes}>
                      {user?.isCustomer === false && (
                        <Button
                          label={loading ? "Serviceable is creating!" : "Create Serviceable"}
                          disabled={loading}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                        </Button>
                      )}
                    </Toolbar>
                  </>
                </Create>
              </Grid>
            </Grid>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetailData?.experience} type={ExperienceNoteType.Serviceable} />
    </>
  );
};

const RbhRequestServiceableCreate = props => {
  return (
    <ServiceableCreate
      resource="/requestserviceables"
      basePath=""
      requestId={props.requestId}
      requestDetail={props.requestDetailData}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default RbhRequestServiceableCreate;
